module.exports = __webpack_public_path__ + "img/aw.530a7832.svg";